module.exports = __webpack_public_path__ + "img/estadio.c5c9334d.jpeg";